import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../shared/services/auth.service';
import { TypeAgentsService } from '../../../pages/type-agents/type-agents.service';
import { TypeAgent } from '../../../pages/type-agents/type-agents.model';

@Component({
  selector: 'app-type-agent-dialog',
  templateUrl: './type-agent-dialog.component.html',
  styleUrls: ['./type-agent-dialog.component.scss'],
  providers: [ TypeAgentsService ]
})
export class TypeAgentDialogComponent implements OnInit {
  public form: FormGroup;
  public passwordHide: boolean = true;
  public typeAgent: TypeAgent;
  public roleId: number;
  // public asdf: (id) => {};
  public toppings = new FormControl();

  constructor(
            public typeAgentsService: TypeAgentsService,
            public dialogRef: MatDialogRef<TypeAgentDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: any,
            public fb: FormBuilder,
            private toastr: ToastrService
        ) {

    this.typeAgent = data.typeAgent;
    console.log(this.typeAgent);

    this.form = this.fb.group({
      id: null,
      created_by: AuthService.getUser().id,
      name: [null, Validators.compose([Validators.required])],
      real_amount: [null, Validators.compose([Validators.required])],
      percent: [null, Validators.compose([Validators.required])],
      amount: null
    });

    console.log('CONSTRUCTOR_USER_DIALOG');
  }

  ngOnInit() {
    if (this.typeAgent) {
      this.form.setValue(this.typeAgent);
    } else {
      this.typeAgent = new TypeAgent();
    }
  }

  save(typeAgent: TypeAgent): void {
    console.log(typeAgent);

    if (typeAgent) {
        this.typeAgentsService.saveTypeAgent(typeAgent).subscribe(exist => {
            this.toastr.info('', typeAgent.id ? 'Tipo de agente actualizado' : 'Tipo de agente creado');
            this.dialogRef.close(typeAgent);
        });
    }

  }

  close(): void {
    this.dialogRef.close(this.typeAgent);
  }

}
